'use client';
import React, { JSX, useState, type FC } from 'react';
import Image from 'next/image';
import styles from './index.module.scss';
import { Modal } from '../modal';
import clsx from 'clsx';

export type Props = {
  size: string;
  material: string;
  src: string | any;
  className: string;
  classNameImg: string;
};

export const ArtPiece: FC<Props> = ({
  size,
  material,
  src,
  className,
  classNameImg,
}): JSX.Element => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <li
      // className={clsx(styles.artPiece, className)}
      className={className}
      onClick={() => setModalIsOpen(true)}
    >
      <Image
        src={src || ''}
        alt={`Artpiece by Karen Oude Alink. Made with ${material} materials and the sizes are: ${size}.`}
        width={150}
        height={150}
        // className={styles.img}
        className={classNameImg}
        sizes="(min-width: 300px) 80vw 60vw 30vw 25vw, (min-width: 600px) 60vw 30vw 25vw, (min-width: 900px) 50vw 30vw 25vw 15vw, (min-width: 1250px) 30vw 25vw 15vw 10vw"
      />
      <Modal
        isOpen={modalIsOpen}
        handleClose={() => setModalIsOpen(false)}
        src={src || ''}
        material={material}
        size={size}
      />
    </li>
  );
};
